export default __webpack_public_path__ + "static/media/at (3).8c1727fe.jpg";